// Danish UI strings — the key shape every other catalog must mirror.
// CMS-fetched content (titles, body, SEO) passes through untouched; these are
// only the code's own labels and the fallbacks shown before the CMS has content.
import { SITE_NAME } from '@/site.config'

export const da = {
  languageName: 'Dansk',
  nav: {
    skipLink:   'Spring til indhold',
    openMenu:   'Åbn menu',
    closeMenu:  'Luk menu',
    logoLabel:  `${SITE_NAME}, til forsiden`,
    primary:    'Primær navigation',
    mobile:     'Mobil navigation',
    footer:     'Footer-navigation',
    language:   'Sprog',
    switchTo:   'Skift til dansk',
    cta:        'Kontakt',
  },

  footer: {
    copyright: (year: number) => `© ${year} ${SITE_NAME}`,
  },

  hero: {
    headline:    'Velkommen',
    subheadline: 'Rediger denne tekst i CMS\'et under Sider → home → Hero.',
    ctaLabel:    'Kontakt os',
  },

  common: {
    loading:     'Henter…',
    error:       'Indholdet kunne ikke hentes lige nu.',
    notFound:    '404',
    notFoundMsg: 'Siden findes ikke.',
    toFrontpage: 'Til forsiden',
    lastUpdated: 'Senest opdateret',
    copied:      'E-mail kopieret!',
  },

  app: {
    materialsTitle: 'Materialer',
    materialsLede:  'Lommekort, vejledninger og medlemsinfo fra FS K&T.',
    allCategories:  'Alle',
    noMaterials:    'Der er ingen materialer i denne kategori endnu.',
    featured:       'Fremhævet',
    seeAll:         'Se alle materialer',
    attachments:    'Filer',
    download:       'Hent',
    reviewed:       'Fagligt gennemgået',
    backToList:     'Alle materialer',
    eventsTitle:    'Arrangementer',
    noEvents:       'Ingen kommende arrangementer.',
    nextEvent:      'Næste arrangement',
    signup:         'Tilmelding',
    news:           'Nyt fra bestyrelsen',
  },

  pageTitles: {
    notFound: 'Siden blev ikke fundet',
  },

  errorPage: {
    title: (status: number) => `Fejl ${status}`,
    heading: 'Noget gik galt',
    body: 'Siden kunne ikke vises lige nu. Prøv igen om lidt.',
  },
} as const
